import type { ComponentProps } from 'react';

import AvatarAi from '../AvatarAi/AvatarAi.jsx';
import SpeakerChip from '../SpeakerChip/SpeakerChip.jsx';

// Cannot use the AgentType from ai-chat because it cycle depends on tw-components
export type AgentType = {
  agentName: string;
  label: string;
  role: ComponentProps<typeof AvatarAi>['role'];
  desc?: string;
  meta?: {
    hasPoweredLabel?: boolean;
    isVisibleInAgentWidget?: boolean;
  };
};

type Props = {
  agent: AgentType;
  isActive: boolean;
  className?: string;
};

const AgentSpeakerChip = ({ agent, className, isActive }: Props) => {
  return (
    <SpeakerChip className={className} isActive={isActive}>
      <AvatarAi size={'small'} role={agent.role} />
      {agent.label}
    </SpeakerChip>
  );
};

export default AgentSpeakerChip;
